import cn from 'classnames';
import React, { FC } from 'react';
import { useAppSelector } from '../../store/hooks';
import { popupSelector } from '../../store/popup/selectors';
import styles from './Popup.module.scss';

const Popup: FC = () => {
    const { text, isShown } = useAppSelector(popupSelector);
    return (
        <div className={cn(styles.popup, { [styles.shown]: isShown })}>
            <span className={styles['popup-text']}>{text}</span>
        </div>
    );
};

export default Popup;
